export const environment = {
    production: false,
    hmr: false,
    stage: true,
    baseApiUrl: 'https://kwnyc-devapi.myplacenyc.com/',
    baseGraphQlUrl: 'https://gateway.kwnyc-dev.realplusonline.com/graphql',
    notificationsApiUrl: 'https://notifications.kwnyc-dev.realplusonline.com/'
};
